/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ workflow: NonNullable<unknown> }} Pwf_Summary_EmptyInputs */

const en_pwf_summary_empty = /** @type {(inputs: Pwf_Summary_EmptyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`From now on this product uses ${i?.workflow}.`)
};

const de_pwf_summary_empty = /** @type {(inputs: Pwf_Summary_EmptyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ab jetzt nutzt dieses Produkt ${i?.workflow}.`)
};

/**
* | output |
* | --- |
* | "From now on this product uses {workflow}." |
*
* @param {Pwf_Summary_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pwf_summary_empty = /** @type {((inputs: Pwf_Summary_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwf_Summary_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pwf_summary_empty(inputs)
	return en_pwf_summary_empty(inputs)
});